import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Authenticate from "../container/admin/auth/login/Login";
import Dashboard from "../components/admin/dashboard/Dashboard";
import DashboardLayout from "../container/admin/pages/dashboardLayout/DashboardLayout";
import ForgotPassword from "../container/admin/auth/forgotPassword/ForgotPassword";
import ResetPassword from "../container/admin/auth/resetPassword/ResetPassword";
import Profile from "../container/admin/pages/profile/Profile";
import ChangePassword from "../container/admin/pages/ChangePassword/ChangePassword";
import SignUp from "../container/admin/auth/signUp/SignUp";
import NewMemberList from "../container/admin/pages/newMember/NewMemberList";
import BankMasterList from "../container/admin/pages/bankmaster/BankMasterList";
import PrivayPolicy from "../container/admin/pages/cms/PrivayPolicy";
import TermsCondition from "../container/admin/pages/cms/TermsCondition";
import Contactus from "../container/admin/pages/cms/Contactus";
import SahaytypeMasterlist from "../container/admin/pages/sahayTypeMaster/SahaytypeMasterlist";
import Subsahaytype from "../container/admin/pages/subsahaytype/Subsahaytype";

import NewMemberAdd from "../container/admin/pages/newMember/NewMemberAdd";
import AddYearOfSahay from "../container/admin/pages/yearofsahay/add/AddYearOfSahay";
import Yearofsahay from "../container/admin/pages/yearofsahay/view/Yearofsahay";
import ApplyForSahay from "../container/user/pages/applyforsahay/ApplyForSahay";
import Listing from "../container/user/pages/listing/Listing";

import SahaytypeAdd from "../container/admin/pages/sahayTypeMaster/SahaytypeAdd";
import SubsahaytypeList from "../container/admin/pages/subsahaytype/SubsahaytypeList";
import SahayApplications from "../container/admin/pages/sahayApplications/SahayApplications";

import UserLogin from "../container/user/auth/login/Login";
import VerifyOTP from "../container/user/auth/login/OTP";
import OTP from "../container/user/auth/login/OTP";

import UserDashboardLayout from "../components/user/dashboard/UserDashboradLayout";
import UserProfile from "../container/user/pages/profile/UserProfile";
import ViewNewMember from "../container/admin/pages/newMember/viewMember/ViewNewMember";
import SahayApplicationView from "../container/admin/pages/sahayApplications/viewDetails/SahayApplicationView";
import ApplyForSahayView from "../container/user/pages/listing/ApplyForSahayView";

import PrivateRoutes from "./UsePrivateRoutes";
import AdminPrivateRoutes from "./AdminPrivateRoutes";
import AdminOtp from "../container/admin/auth/otp/OTP";
import EditApplyForSahay from "../container/user/pages/listing/EditApplyForSahay";
import RoleMasterList from "../container/admin/pages/rollmaster/RoleMasterList";
import RoleMasterAdd from "../container/admin/pages/rollmaster/RoleMasterAdd";
import UserMasterList from "../container/admin/pages/userMaster/UserMasterList";
import UserMasterAdd from "../container/admin/pages/userMaster/UserMasterAdd";
import ViewUserMaster from "../container/admin/pages/userMaster/ViewUserMaster";
import UserSetting from "../container/user/pages/userSetting/UserSetting";
import RolePermission from "../container/admin/pages/rolepermission/RolePermission";
import PreviousApplyForSahay from "../container/user/pages/applyforsahay/PreviousApplyForSahay";
import PreviousSahayApplicationView from "../container/admin/pages/sahayApplications/viewDetails/PreviousSahayApplicationView";
import EditCurrentApplyForSahay from "../container/user/pages/applyforsahay/EditCurrentApplyForSahay";
import DisbursementList from "../container/admin/pages/Disbursement/DisbursementList";
import AddDisbursement from "../container/admin/pages/Disbursement/AddDisbursement";
import ViewDisbursementData from "../container/admin/pages/Disbursement/ViewDisbursementData";
import ApplyForSahayAdmin from "../container/admin/pages/AddSahayAplicationAdmin/AddSahayApplicationAdmin";
import FamilyReport from "../container/admin/pages/familyReport/FamilyReport";
import ApplicationReport from "../container/admin/pages/applicationReport/ApplicationReport";
import CommiteReport from "../container/admin/pages/commiteReport/CommiteReport";
import SahayWiseDetails from "../container/admin/pages/sahayWiseDetails/SahayWiseDetails";
import EscReport from "../container/admin/pages/escReort/EscReport";
import DisbursementReport from "../container/admin/pages/disbursementReport/DisbursementReport";
import RepaymentReport from "../container/admin/pages/repaymentReport/RepaymentReport";
import FamilyReportData from "../container/admin/pages/familyReportData/FamilyReportData";
import AdminDashboard from "../container/admin/pages/dashboard/AdminDashboard";
import ActivityLog from "../container/admin/pages/activityLog/ActivityLog";
import NewReport from "../container/admin/pages/NewReport/NewReport";
import DisbursementSummaryList from "../container/admin/pages/disbursementSummary/DisbursementSummaryList";
import Program from "../container/admin/pages/program/Program";
import AddEditProgram from "../container/admin/pages/program/AddEditProgram";
import MassDisbursement from "../container/admin/pages/Disbursement/MassDisbursment";
import RecoveryLoan from "../container/admin/pages/recoveryLoan/RecoveryLoan";
import RecoveryAddEdit from "../container/admin/pages/recoveryLoan/RecoveryAddEdit";
import BillList from "../container/admin/pages/billManagement/BillList";
import AddBill from "../container/admin/pages/billManagement/AddBill";
import DisbursementBill from "../container/admin/pages/billManagement/DisbursmentBill";
import AddEditBillDisbursement from "../container/admin/pages/billManagement/AddEditBillDisbursement";
import ViewBill from "../container/admin/pages/billManagement/ViewBill";
import ViewBillDisbursement from "../container/admin/pages/billManagement/ViewBillDisbursement";
import DonnerTypeAdd from "../container/admin/pages/donnerTypeMaster/DonnerTypeAdd";
import DonnerTypeMasterList from "../container/admin/pages/donnerTypeMaster/DonnerTypeMasterList";
import SahayApplicationReportView from "../container/admin/pages/sahayApplicationReportView/SahayApplicationReportView";
import PendingDisbursement from "../container/admin/pages/pendingDisbursement/PendingDisbursement";
import ProgramReport from "../container/admin/pages/ProgramReport/ProgramReport";
import LoanReport from "../container/admin/pages/loanReport/LoanReport";
import ProgramReportMemberView from "../container/admin/pages/ProgramReport/ProgramReportView";
import LoanReportView from "../container/admin/pages/loanReport/LoanReportView";
import MasterReport from "../container/admin/pages/applicationMasterReport/MasterReport";
import PendingSahayApplicaitonByStaffReport from "../container/admin/pages/pendingShayaApplicationReport/PendingSahayApplicationByStaffReport";
import HeadOfTheFamilyReport from "../container/admin/pages/headOfTheFamilyReport/HeadOfTheFamilyReport";
import ImageView from "../container/user/pages/listing/ImageView";
import AdminImageView from "../container/admin/pages/sahayApplications/viewDetails/Admin_Image_view";

const Routers = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/login" element={<Authenticate />} />
        <Route path="/user/verify-otp" element={<OTP />} />

        {/* Auth routes */}
        <Route path="/" element={<UserLogin />} />
        <Route path="/admin/forgot-password" element={<ForgotPassword />} />
        <Route path="/admin/verify-otp" element={<AdminOtp />} />
        <Route path="/admin/reset-password" element={<ResetPassword />} />
        <Route path="image-view" element={<ImageView />} />
        
        {/* Pages routes */}
        {/* <Route element={<AdminPrivateRoutes />}> */}
        <Route element={<AdminPrivateRoutes />}>
          <Route path="/:roll" element={<DashboardLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="type-master" element={<SahaytypeMasterlist />} />
            <Route path="type-master-add" element={<SahaytypeAdd />} />
            <Route path="subtype-master" element={<SubsahaytypeList />} />
            <Route path="subtype-master-add" element={<Subsahaytype />} />

            <Route path="donner-name-add" element={<DonnerTypeAdd />} />
            <Route
              path="donnertype-master"
              element={<DonnerTypeMasterList />}
            />

            <Route path="user-master" element={<UserMasterList />} />
            <Route path="user-master-add" element={<UserMasterAdd />} />
            <Route path="user-master-view" element={<ViewUserMaster />} />
            <Route path="apply-for-sahay" element={<ApplyForSahay />} />
            <Route path="program-master" element={<Program />} />
            <Route path="add-edit-program" element={<AddEditProgram />} />
            <Route path="mass-disbursement" element={<MassDisbursement />} />
            <Route path="recovery-loan" element={<RecoveryLoan />} />
            <Route path="add-edit-recovery" element={<RecoveryAddEdit />} />
            <Route path="bill-list" element={<BillList />} />
            <Route path="add-edit-bill" element={<AddBill />} />
            <Route path="view-bill" element={<ViewBill />} />
            <Route path="disbursed-bill-list" element={<DisbursementBill />} />
            <Route
              path="add-edit-bill-disbursement"
              element={<AddEditBillDisbursement />}
            />
            <Route
              path="view-bill-disbursement"
              element={<ViewBillDisbursement />}
            />

            {/* <Route path="admin/dashboard" element={<AdminDashboard />} /> */}

            <Route
              path="apply-for-sahay-admin"
              element={<ApplyForSahayAdmin />}
            />
            <Route
              path="edit-apply-for-sahay-admin"
              element={<ApplyForSahayAdmin />}
            />
            <Route
              path="apply-for-previous-sahay"
              element={<PreviousApplyForSahay />}
            />
            <Route
              path="edit-apply-for-previous-sahay"
              element={<PreviousApplyForSahay />}
            />
            <Route
              path="edit-apply-for-current-sahay"
              element={<EditCurrentApplyForSahay />}
            />
            <Route path="role-permission" element={<RolePermission />} />
            <Route path="new-member">
              <Route path="list" element={<NewMemberList />} />
              <Route path="add" element={<NewMemberAdd />} />
              <Route path="view" element={<ViewNewMember />} />
            </Route>
            <Route path="bank-master" element={<BankMasterList />} />
            <Route path="sahay-application" element={<SahayApplications />} />
            <Route
              path="sahay-application-view"
              element={<SahayApplicationView />}
            />
            <Route
              path="previous-sahay-application-view"
              element={<PreviousSahayApplicationView />}
            />
            <Route
              path="edit-previous-sahay-application-view"
              element={<PreviousSahayApplicationView />}
            />
            <Route
              path="disbursement-application"
              element={<DisbursementList />}
            />
            <Route
              path="add-disbursement-application"
              element={<AddDisbursement />}
            />
            <Route
              path="edit-disbursement-application"
              element={<AddDisbursement />}
            />
            <Route
              path="view-disbursement"
              element={<ViewDisbursementData />}
            />
            <Route path="change-password" element={<ChangePassword />} />
            <Route path="update-profile" element={<Profile />} />
            <Route path="year-of-sahay">
              <Route path="view" element={<Yearofsahay />} />
              <Route path="add" element={<AddYearOfSahay />} />
            </Route>
            <Route path="role-master">
              <Route path="list" element={<RoleMasterList />} />
              <Route path="add" element={<RoleMasterAdd />} />
            </Route>
            <Route path="activity-log" element={<ActivityLog />} />

            <Route path="family-report" element={<FamilyReport />} />
            <Route path="family-wise-report" element={<FamilyReportData />} />
            <Route path="sahay-wise-report" element={<SahayWiseDetails />} />
            <Route path="commite-report" element={<CommiteReport />} />
            <Route path="repayment-report" element={<RepaymentReport />} />
            <Route path="newreport-report" element={<NewReport />} />
            <Route path="master-report" element={<MasterReport />} />
            <Route
              path="staff-pending-sahay-application"
              element={<PendingSahayApplicaitonByStaffReport />}
            />
            <Route
              path="disbursement-report"
              element={<DisbursementReport />}
            />
            <Route
              path="disbursement-summary"
              element={<DisbursementSummaryList />}
            />
            <Route path="esc-report" element={<EscReport />} />
            <Route path="application-report" element={<ApplicationReport />} />
            <Route path="terms-and-condition" element={<TermsCondition />} />
            <Route path="privacy-policy" element={<PrivayPolicy />} />
            <Route path="contact-us" element={<Contactus />} />
            <Route
              path="sahay-report-view"
              element={<SahayApplicationReportView />}
            />
            <Route
              path="pending-disbursement-report"
              element={<PendingDisbursement />}
            />
            <Route path="program-report" element={<ProgramReport />} />
            <Route
              path="program-report-member-view"
              element={<ProgramReportMemberView />}
            />
            <Route path="loan-report" element={<LoanReport />} />
            <Route
              path="loan-report-Installment-view"
              element={<LoanReportView />}
            />
            <Route
              path="head-of-the-family-report"
              element={<HeadOfTheFamilyReport />}
            />
            <Route path="doc-image-view" element={<AdminImageView />} />
          </Route>
        </Route>
        {/* </Route> */}
        <Route element={<PrivateRoutes />}>
          <Route path="/user" element={<UserDashboardLayout />}>
            <Route path="user-listing" element={<Listing />}></Route>
            <Route path="user-listing-view" element={<ApplyForSahayView />} />
            <Route path="user-listing-edit" element={<EditApplyForSahay />} />
            <Route path="apply-for-sahay" element={<ApplyForSahay />} />
            {/* <Route path="update-profile" element={<UserProfile />} /> */}
            <Route path="setting" element={<UserSetting />} />

            <Route path="update-profile" element={<UserProfile />} />
          </Route>
        </Route>

        {/* <Route path="/:role" element={<DashboardLayout  />}>
        <Route path="contact-us" element={<Contactus />} />
        </Route> */}
      </Routes>
    </BrowserRouter>
  );
};

export default Routers;
